const backpackItems = [
    // ✨ Magical but Mundane
    "A quill that never runs out of ink... but only writes in Goblin.",
    "Teacup that warms slightly when someone lies near it.",
    "A scarf that always flutters, even without wind.",
    "Tiny hourglass that glows softly when you're late.",
    "A spoon that makes any food taste faintly of honey.",
    "Glowing pebble labeled 'DO NOT EAT'.",
    "A bar of soap that never wears down—but refuses to clean blood.",
    "A wooden acorn that hums when held during sunrise.",
    "Teapot that whispers gossip when steeping tea.",
    "A set of dice that never roll the same number twice.",
    "Pocketwatch that ticks louder around danger.",
    "A tiny broom that sweeps on its own, but only at night.",
    "Ink pot that changes color based on mood.",
    "A hand mirror that always compliments your outfit.",
    "Mug that refills with water when held over your head.",
    "Shoelaces that retie themselves when whispered to.",
    "Blanket that hums lullabies when draped.",
    "A fork that detects poison by vibrating softly.",
    "A notebook where yesterday’s notes fade away.",
    "Paper crane that flaps once a week, no one knows why.",
    "Socks that never get holes but are always slightly damp.",
    "Pebble that glows when you're about to trip.",
    "Spoon that stirs by itself—but only counterclockwise.",
    "Bookmark that jumps to the last page you read aloud.",
    "Candle that smells like nostalgia but never burns down.",
    "Necklace that hums quietly when you're being watched.",
    "Pencil that never dulls, but writes in rhymes.",
    "Pillow that makes every nap exactly 27 minutes.",
    "Soap that always smells like your favorite food.",
    "Comb that untangles thoughts more than hair.",
    "Nail that can pin anything, even shadows.",
    "Gloves that glow faintly in the dark—only when lost.",
    "A book that refuses to open unless whispered to.",
    "Mirror that shows you with perfect posture.",
    "Cup that cools boiling water to perfect tea temp.",
    "Matchbox that laughs when struck.",
    "Scarf that always matches your current outfit.",
    "Spoon that flips when near soup.",
    "Candle that flickers to music.",
    "Feather that tickles only when ignored.",
    "Envelope that seals itself with dramatic flair.",
    "Bell that rings every time a deal is made nearby.",
    "Pebble that hums lullabies if left under a pillow.",
    "Button that teleports to your pocket once a day.",
    "Earmuffs that only muffle gossip.",
    "Tiny parasol that keeps bread fresh.",
    "Eyedropper that turns water into perfectly clear ink.",
    "Mask that makes everyone sound like bards.",
    "Blanket that folds itself but never the same way twice.",
    "Soap bubble that never pops… just floats off.",
    // 💔 Sentimental & Personal
    "Worn locket with a faded painting of a loved one.",
    "Crumpled love letter addressed to no one.",
    "Broken necklace from an ex—still kind of hurts.",
    "Childhood stuffed bear with one eye.",
    "A journal with no empty pages, filled with memories.",
    "Handwritten recipe for 'Grandma’s Phoenix Pie'.",
    "Wooden ring engraved with initials you don’t remember.",
    "Song lyrics scrawled on a torn napkin.",
    "Dog tag of a pet long gone.",
    "Pressed flower from your hometown.",
    "Bracelet made of tiny animal bones.",
    "Letter of recommendation from someone who disappeared.",
    "Old to-do list with 'be brave' at the top.",
    "Tiny sketchbook with rough portraits of your party.",
    "Map marked with 'home' and a little heart.",
    "A ticket stub to a circus no longer in business.",
    "Your old school sash, stained and tattered.",
    "A wishbone, wrapped in ribbon.",
    "A key to a home that doesn't exist anymore.",
    "The first coin you ever earned, polished smooth.",
    "Faded photo of people you don’t recognize, but miss.",
    "Hairpin from someone you almost married.",
    "Collage of old receipts, tickets, and scribbled notes.",
    "Friendship bracelet—yours is the only one left.",
    "Smudged page of a once-shared storybook.",
    "A letter written in your own handwriting, but no memory of writing it.",
    "Baby tooth in a small pouch.",
    "Empty vial labeled 'tears from the first time'.",
    "A broken flute carved with initials.",
    "Birthday card from someone long gone.",
    "Piece of ribbon that still smells like home.",
    "Shell with a child's voice faintly recorded in it.",
    "Pet collar, name tag scratched off.",
    "Charred bit of paper with a lullaby on it.",
    "Dull ring that only fits when you're feeling brave.",
    "Tiny painted stone with your birthdate on it.",
    "Cracked monocle—useless, but comforting.",
    "Braided lock of someone else's hair.",
    "A string tied in a complicated knot—no one remembers why.",
    "Scrap of a blanket with a name stitched in.",
    "Drawing from a child in another life.",
    "An old guild badge, worn smooth from use.",
    "Crumpled note that says “I forgive you.”",
    "Tattered bandana from a long-dead companion.",
    "Feather from your first familiar.",
    "Empty perfume bottle with a chipped glass rose.",
    "Puzzle piece that doesn’t fit any puzzle you know.",
    "Chalk drawing on parchment, half-erased by tears.",
    "Clay coin from a game you played in the streets.",
    "A carved wooden frog named Lucky. You still believe.",
    // 🐸 Weird, Funny, or Gross
    "Tiny plush snail named Greg (he’s sticky).",
    "A bottle labeled 'Lick Me Later'.",
    "Half-eaten sandwich, still warm somehow.",
    "Rock that looks exactly like a butt.",
    "Socks that scream when lost.",
    "Bag of dirt that insists it's 'sentient'.",
    "Journal filled with conspiracy theories about horses.",
    "Drawing of you... but you've never seen it before.",
    "Banana peel preserved in resin like it's important.",
    "Tunic with a ketchup stain shaped like a dragon.",
    "A small bell that only rings when ignored.",
    "Mystery meat jerky, allegedly 'kobold-free'.",
    "A hat that constantly falls off, even when strapped.",
    "Book titled 'How to Speak Duck'.",
    "A clump of your own hair. You don’t remember saving it.",
    "Teeth. Just… loose teeth in a pouch.",
    "Handwritten fanfiction featuring you and a lich.",
    "Enchanted kazoo that echoes forever.",
    "Miniature lute that only plays sea shanties.",
    "Coin pouch full of buttons and lint labeled 'Emergency Fund'",
    "Egg that’s been vibrating for days.",
    "Squeaky toy that’s always damp.",
    "Half-finished drawing of a naked troll.",
    "Jar labeled “Don’t Sniff This.” You always do.",
    "Hat made entirely of pocket lint.",
    "Lizard tail that wiggles every Tuesday.",
    "Slime mold named Jennifer (she’s “housebroken”).",
    "A mug that moos when filled.",
    "Hand puppet of a goblin—it bites.",
    "Sock full of jellybeans and regret.",
    "Cheese wheel with a monocle.",
    "Accordion that screams when played badly.",
    "Soap that smells like garlic no matter what.",
    "Blanket embroidered with bad jokes.",
    "Earwax candle, mint-scented.",
    "Gnome-sized lederhosen.",
    "Inexplicably sticky pouch.",
    "Leaf pressed between pages, labeled “Fred”.",
    "Toad statue that farts if touched.",
    "Pickle in a sealed glass box labeled “do not open”.",
    "Severed fake hand with painted nails.",
    "A rusty spoon named “Clarence.”",
    "Bag of trail mix, entirely raisins.",
    "A whistle that calls squirrels.",
    "Self-inking stamp that only prints butts.",
    "Lantern that smells faintly of cheese.",
    "Nose glasses with no lenses.",
    "Mirror that reflects you as a frog.",
    "Book that contains only “meow” written repeatedly.",
    "Soup ladle with a built-in compass (it’s broken).",
    // 🔮 Cursed or Suspicious
    "A mirror that doesn’t reflect your eyes.",
    "A coin that always lands on its edge.",
    "Book you can’t open… unless you’re bleeding.",
    "A mask that frowns when you smile.",
    "Potion labeled 'Definitely Not Poison' (it's empty).",
    "A ring that can’t be removed. You don't remember putting it on.",
    "Tiny music box that plays even when closed.",
    "Dice that whisper your name when rolled.",
    "Compass that points away from safety.",
    "Scroll that bursts into flame when read aloud.",
    "Necklace with a faint heartbeat.",
    "A doll that resembles someone you just met.",
    "Rusted bell that only rings during eclipses.",
    "Bone fragment with your name etched into it.",
    "A shadow in a bottle. Sometimes it moves.",
    "Tarot card that always draws 'The End'.",
    "Sealed envelope marked ‘OPEN WHEN YOU DIE’.",
    "Broken wand still warm to the touch.",
    "Old coin with a fanged smile etched into it.",
    "Eyeglass that shows people as skeletons.",
    "Spoon that reflects your greatest fear.",
    "Mask that won't come off if worn too long.",
    "Bottle that refills with foul-smelling fluid daily.",
    "Amulet that whispers wrong answers to riddles.",
    "Coin purse that gets lighter with each compliment.",
    "Candle that lights itself near undead.",
    "Skeleton key… that unlocks *something*.",
    "Tiny box that rattles unless you’re holding your breath.",
    "Journal that erases itself every night.",
    "Cloak that feels wet and never dries.",
    "Ring that burns a new scar every moon cycle.",
    "Bookmark that turns every page to warnings.",
    "Music sheet for a melody no one should hear.",
    "Stone that skips across dry ground.",
    "Teeth that hum when danger is near… or just hungry.",
    "A chain with no ends.",
    "A bell that tolls hours that don’t exist.",
    "Tattoo ink that changes shape at night.",
    "Rope that knots itself around your fingers.",
    "Feather that floats upward… endlessly.",
    "A box of matches that screams when lit.",
    "Nail file that leaves your nails sharper.",
    "Broken spectacles that reveal secrets—but only once.",
    "Dagger-shaped charm that draws blood in dreams.",
    "Marble that rolls toward you if you lie.",
    "Small mirror that shows your back.",
    "Cup that makes all water taste like ash.",
    "Painting of you sleeping—updated daily.",
    "Envelope with wax seal of your birthmark.",
    "Candle stub that only burns in reverse.",
    // 🧰 Survival & Utility
    "Flint and steel, surprisingly reliable.",
    "Whetstone carved with celestial runes.",
    "A small shovel with a collapsible handle.",
    "Tiny vial of salt—very useful.",
    "Water flask that keeps liquids cold.",
    "Fire starter that sparks blue.",
    "Needle and thread, well-used.",
    "Pocket-sized compass with a missing needle.",
    "Set of thieves’ tools wrapped in velvet.",
    "Multi-purpose hook on a long cord.",
    "Tent peg. Just one. No tent.",
    "Lantern missing its oil.",
    "Map of an unknown dungeon.",
    "Small block of wax for sealing letters.",
    "Hand-drawn calendar with cryptic marks.",
    "Jar of pickled vegetables.",
    "Mirror shard in a cloth wrap.",
    "Rope with suspicious fraying.",
    "Compass that spins endlessly.",
    "Charcoal and paper with faded sketches.",
    "Waterproof matchbook with only one match left.",
    "Foldable stool made from dried mushrooms.",
    "Copper whistle—silent to you, loud to beasts.",
    "Sealing wax that never melts.",
    "Kit of bones for impromptu divination.",
    "Spool of near-invisible thread.",
    "Metal pick that hums near hollow walls.",
    "Soap bar shaped like a dragon egg.",
    "Collapsible basin for quick washing or spellwork.",
    "Wooden peg labeled “tent or stake, your call.”",
    "Pouch of dried beans for food or planting.",
    "Tiny mirror that magnifies moonlight.",
    "Rope ladder, 5 ft. long—but stretches if yelled at.",
    "Oilskin map case that repels water and fire.",
    "Metal file hidden in a hairbrush.",
    "Compass that only works near ley lines.",
    "Flask with two compartments—don’t mix them.",
    "Portable pan that heats without fire.",
    "Candle stub that never fully burns out.",
    "Fireproof gloves, slightly stiff.",
    "Chalk stick with 100 uses (and a tally mark counter).",
    "Deck of blank cards, useful as notes or flashbangs.",
    "Bone whistle that repels rats.",
    "Folding knife with compass in the hilt.",
    "Fishing line that glows under moonlight.",
    "Book of edible plants, water-damaged but usable.",
    "Jar of honey that seals wounds.",
    "String with 12 knots, each for a different use.",
    "Empty bottle labeled “In case of emergency—scream.”",
    "Travel pillow with hidden storage pouch.",
];

export default backpackItems;
